import Container from '@material-ui/core/Container'
import { makeStyles } from '@material-ui/core/styles'
import React from 'react'
import { useForm } from '../../providers'
import { BookingFormPartOne } from './components/BookingFormPartOne'
import { BookingFormPartTwo } from './components/BookingFormPartTwo'
import Stepper from './components/Stepper'

const useStyles = makeStyles((theme) => {
    return {
        formContainer: {
            backgroundColor: '#FFFEFE',
            minHeight: '92vh',
        },
        container: {
            width: '100%',
            backgroundColor: '#FFFEFE',
            [theme.breakpoints.up('sm')]: {
                width: '60%',
            },
        },
    }
})

function Booking() {
    const classes = useStyles()
    const { activeStep } = useForm()

    return (
        <div className={classes.formContainer}>
            <Stepper activeStep={activeStep} />
            <Container className={classes.container}>
                {activeStep === 1 && <BookingFormPartOne />}
                {activeStep === 2 && <BookingFormPartTwo />}
            </Container>
        </div>
    )
}

export default Booking
